/** Polish labels stay as internal keys (permissions matching). Display uses i18n. */
export const NAV_LABEL_TO_I18N_KEY: Record<string, string> = {
  Klub: "nav.club",
  Zajęcia: "nav.events",
  Drafty: "nav.drafts",
  Cykliczne: "nav.cyclical",
  Monitoring: "nav.monitoring",
  Zawodnicy: "nav.players",
  Nabór: "nav.recruitment",
  Zgłoszenia: "nav.applications",
  Radar: "nav.radar",
  Trenerzy: "nav.trainers",
  "Rekrutacja trenerów": "nav.trainerRecruitment",
  Kandydaci: "nav.candidates",
  "Dostępni trenerzy": "nav.availableTrainers",
  Sklep: "nav.shop",
  "Wydarzenia płatne": "nav.paidEvents",
  Zamówienia: "nav.orders",
  Składki: "nav.passes",
  Kupony: "nav.coupons",
  Produkty: "nav.products",
  Kategorie: "nav.categories",
  Atrybuty: "nav.attributes",
  Dostawy: "nav.deliveries",
  Personel: "nav.staff",
  Konspekty: "nav.concepts",
  Teczka: "nav.files",
  System: "nav.system",
  Dostępy: "nav.access",
  Posty: "nav.posts",
};

export const getNavLabelKey = (label: string) =>
  NAV_LABEL_TO_I18N_KEY[label] || label;
